import { Box, Card, CardContent, Typography, Button, Stack, Grid } from '@mui/material'
import {
  Mail as MailIcon,
  Edit as EditIcon,
  People as PeopleIcon,
  BarChart as AnalyticsIcon,
} from '@mui/icons-material'
import { themeColors } from '../../app/layout/theme'

export const MarketingPage = () => {
  const features = [
    {
      title: 'Email Campaigns',
      description: 'Create and manage email marketing campaigns',
      icon: <MailIcon />,
    },
    {
      title: 'Custom Landing Pages',
      description: 'Build landing pages without coding',
      icon: <EditIcon />,
    },
    {
      title: 'Audience Building',
      description: 'Target and segment your audiences',
      icon: <PeopleIcon />,
    },
    {
      title: 'Pre-Built Analytics',
      description: 'Track campaign performance',
      icon: <AnalyticsIcon />,
    },
  ]

  return (
    <Box sx={{ padding: 3 }}>
      <Card sx={{ backgroundColor: themeColors.surface, borderRadius: 2 }}>
        <CardContent>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Unlock Marketing Cloud
            </Typography>
            <Typography sx={{ color: themeColors.text.secondary, mb: 3 }}>
              Upgrade your plan to access powerful marketing automation and campaign management
              tools.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: themeColors.primary,
                px: 3,
              }}
            >
              Upgrade Now
            </Button>
          </Box>

          <Grid container component="div" spacing={3}>
            {features.map((feature, index) => (
              <Grid component="div" size={{ xs: 12, sm: 6 }} key={index}>
                <Card
                  sx={{
                    backgroundColor: '#f8f8f8',
                    borderRadius: 2,
                    border: `1px solid ${themeColors.border}`,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: 3,
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      fontSize: 48,
                      color: themeColors.primary,
                      mb: 2,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    {feature.title}
                  </Typography>
                  <Typography sx={{ color: themeColors.text.secondary }}>
                    {feature.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}
